// Module
var code = `<div class="form-group"> <label class="col-sm-{{ formController.labelWidth }} control-label"></label> <div class="col-sm-{{ 12 - formController.labelWidth }}"> <div class="form-input-container"></div> </div> </div> `;
// Exports
module.exports = code;